import { lazy } from 'react';

const components = {
  a1: lazy(() => import('./_components/SimplifiedBobDoodle')),
  a2: lazy(() => import('./_components/ManualFlowCalculator')),
};

interface HeaderSectionProps {
  variant: 'a1' | 'a2';
}

const HeaderSection = ({ variant }: HeaderSectionProps) => {
  let valid = false;
  if (components[variant]) {
    valid = true;
  }
  const Component = valid ? components[variant] : components.a1;

  return <Component />;
};

export default HeaderSection;
